import { useMemo } from 'react'

import { Conversation, Participant } from '@app/models'

export const useMainBuyerOrRenter = (
  conversation: Conversation | null
): Participant | null => {
  return useMemo(() => {
    if (!conversation) {
      return null
    }

    return (
      conversation.participants.find(
        (participant) => participant.role === 'MainBuyerOrRenter'
      ) || null
    )
  }, [conversation])
}
